export default __webpack_public_path__ + "assets/images/51e9b33ac7e28a138b0ec1d970be1bdf.png";